/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link, useLocation } from "react-router-dom";
import { FlexContainer, Tag, theme, Tooltip } from "@nordcloud/gnui";
import { Maybe } from "~/generated/graphql";
import { ROUTES } from "~/routing/routes";

type OrgUnit = {
  nid: string;
  name: string;
  businessContext: {
    id: string;
    name: string;
    color?: Maybe<string>;
  };
};

type Props = {
  orgUnits: OrgUnit[];
  readOnly?: boolean;
};

export function OrgUnitTags({ orgUnits, readOnly = false }: Props) {
  const location = useLocation();

  return (
    <>
      {orgUnits.map((unit) => {
        return (
          <div key={unit.nid} css={{ position: "relative", display: "flex" }}>
            <Link
              key={unit.nid}
              to={
                readOnly
                  ? location.pathname
                  : `${ROUTES.businessContexts.index}/${unit.businessContext.id}/${unit.nid}`
              }
            >
              <Tooltip
                caption={`In Business Context ${unit?.businessContext?.name} this environment belongs to ${unit.name}.`}
              >
                <FlexContainer>
                  <Tag
                    text={unit.name}
                    color={unit?.businessContext?.color || theme.colors.white}
                  />
                </FlexContainer>
              </Tooltip>
            </Link>
          </div>
        );
      })}
    </>
  );
}
